<template>
  <vs-popup class="add-sundry-cost-popup" id="popup" :title="isCreateMode ? 'ADD DEFAULT SUNDRY COST' : 'UPDATE DEFAULT SUNDRY COST'"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-sundry-cost-popup" @submit.prevent="handleSubmit(onClickCreateCost)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="cost" name="cost" rules="required" v-slot="{ errors }">
                <small class="label">Cost (GBP/KG)</small>
                <vs-input v-model="form.cost" name="cost" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="formulation_type" name="formulation_type" rules="required" v-slot="{ errors }">
                <small class="label">Formulation Type</small>
                <v-select name="type" :closeOnSelect="true" v-model="form.formulation_type"
                  :options="['powder', 'liquid', 'spray dry powder', 'fruit']" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="!isCreateMode" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" v-model="form.note" height="150px" />
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-user-type-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const SundryCostRepository = RepositoryFactory.get('sundry_cost');
import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    id: '',
    form: {
      cost: '',
      formulation_type: '',
      note: ''
    },
    isCreateMode: true
  }
}

export default {
  name: 'AddNewSundryCostPopUp',
  data() {
    return initialState()
  },
  components: {
    'v-select': vSelect,
  },
  methods: {
    async openPopup(id) {
      try {
        Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.open = true;
        if (!!id) {
          this.id = id
          this.isCreateMode = false
          await this.fetchMarginCost()
        } else {
          this.isCreateMode = true
        }
      } catch (error) {
        this.convertAndNotifyError(error);
      }
    },
    async fetchMarginCost() {
      await this.$vs.loading({
        container: '#create-sundry-cost-popup',
        scale: 0.45
      })
      try {
        const { data } = (await SundryCostRepository.getSundryCost(this.id)).data
        this.form = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-sundry-cost-popup > .con-vs-loading')
    },
    async onClickCreateCost() {
      const vue = this;
      await this.$vs.loading({
        container: '#create-sundry-cost-popup',
        scale: 0.45
      })
      try {
        this.form.cost = Number(this.form.cost).toFixed(2)
        this.form.formulation_type = this.form.formulation_type.toLocaleLowerCase()
        if (this.isCreateMode) {
          await SundryCostRepository.createSundryCost(this.form);
          this.showSuccessMessage('Sundry cost added!');
        } else {
          await SundryCostRepository.updateSundryCost(this.id, this.form);
          this.showSuccessMessage('Sundry cost updated!');
        }
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.$vs.loading.close('#create-sundry-cost-popup > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-sundry-cost-popup > .con-vs-loading')
    },
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.add-sundry-cost-popup>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 30% !important;
}
</style>
